<template>
	<div class="form-container">
		<form @submit.prevent="onSubmitForm">
			<section>
				<h2 class="form-title">개인 정보</h2>

				<div class="form-group" :class="{ 'has-error': validMessage.userName }">
					<label class="form-label">
						이름 <span class="form-help form-help--required">*</span>
					</label>
					<input v-model="userName" class="form-input" type="text" />

					<FormInputHint :message="validMessage.userName"></FormInputHint>
				</div>

				<div class="form-group">
					<label class="form-label">
						휴대전화 번호 <span class="form-help form-help--required">*</span>
					</label>

					<div :class="{ 'has-error': validMessage.userHp }">
						<div class="columns">
							<div class="column col-7">
								<input
									v-model="userHp"
									class="form-input"
									type="text"
									placeholder="- 없이 숫자만 입력"
									:readonly="isCertSuccess"
								/>
							</div>
							<div class="column col-5">
								<Btn
									v-if="!isSendCertSms"
									@click="onClickSendCertSms"
									type="button"
									color="primary"
									medium
									block
									:disabled="validMessage.userHp !== ''"
								>
									인증번호 받기
								</Btn>
								<Btn
									v-else
									@click="onClickSendCertSms"
									type="button"
									color="secondary"
									medium
									block
									:disabled="validMessage.userHp !== '' || isCertSuccess"
								>
									인증번호 재발송
								</Btn>
							</div>
						</div>

						<FormInputHint :message="validMessage.userHp"></FormInputHint>
					</div>

					<!-- 인증번호 전송 성공 후 노출 -->
					<div v-if="isSendCertSms">
						<div class="columns">
							<div class="column col-12">
								<input
									v-model="certNumber"
									class="form-input"
									type="text"
									placeholder="인증번호 입력"
									:class="{
										'is-success': isCertSuccess,
										'is-error': !isCertSuccess && validCertNumber,
									}"
									:readonly="isCertSuccess"
								/>

								<FormInputHint :message="validCertNumber"></FormInputHint>
							</div>
							<div v-if="!isCertSuccess" class="column col-12">
								<Btn
									@click="onClickCheckCertNumber"
									type="button"
									color="primary"
									medium
									block
									:disabled="!certNumber"
									>확인
								</Btn>
							</div>
						</div>
					</div>
				</div>
			</section>

			<hr class="form-hr" />

			<section>
				<h2 class="form-title">로그인 정보</h2>
				<div class="form-group">
					<label class="form-label">
						아이디 <span class="form-help form-help--required">*</span>
					</label>

					<div
						:class="{
							'has-success': isUserIdSuccess,
							'has-error':
								!isUserIdSuccess && (validMessage.userId || validCheckUserId),
						}"
					>
						<div class="columns">
							<div class="column col-9">
								<input
									v-model="userId"
									class="form-input"
									type="text"
									placeholder="영문 소문자로 시작, 숫자/밑줄(_) 포함 6~12자"
								/>
							</div>
							<div class="column col-3">
								<!-- 21.05.28 | SD | 유효한 아이디이지만 중복확인 버튼 비활성화가 안풀리는 오류 임시 수정 -->
								<!--
                                <Btn @click="onClickCheckUserId" type="button" color="primary"
                                     medium block
                                     :disabled="validMessage.userId !== ''">
                                    중복확인
                                </Btn>
                                -->
								<Btn
									@click="onClickCheckUserId"
									type="button"
									color="primary"
									medium
									block
								>
									중복확인
								</Btn>
							</div>
						</div>

						<FormInputHint :message="validMessage.userId"></FormInputHint>
						<FormInputHint :message="validCheckUserId"></FormInputHint>
					</div>
				</div>

				<div class="form-group" :class="{ 'has-error': validMessage.userPw }">
					<label class="form-label">
						비밀번호 <span class="form-help form-help--required">*</span>
					</label>
					<input
						v-model="userPw"
						class="form-input"
						type="password"
						placeholder="영문 대소문자, 숫자, 특수문자 중 2종류 이상 조합으로 이루어진 8~16자"
					/>

					<FormInputHint :message="validMessage.userPw"></FormInputHint>
				</div>

				<div class="form-group" :class="{ 'has-error': validMessage.reUserPw }">
					<label class="form-label">
						비밀번호 확인 <span class="form-help form-help--required">*</span>
					</label>
					<input
						v-model="reUserPw"
						class="form-input"
						type="password"
						placeholder="영문 대소문자, 숫자, 특수문자 중 2종류 이상 조합으로 이루어진 8~16자"
					/>

					<FormInputHint :message="validMessage.reUserPw"></FormInputHint>
				</div>
			</section>

			<hr class="form-hr" />

			<section>
				<div
					class="form-group"
					:class="{ 'has-error': validMessage.userEmail }"
				>
					<label class="form-label">
						이메일 <span class="form-help form-help--required">*</span>
					</label>
					<EmailInput v-model="userEmail"></EmailInput>

					<FormInputHint :message="validMessage.userEmail"></FormInputHint>
				</div>

				<div
					class="form-group"
					:class="{ 'has-error': validMessage.userBirth }"
				>
					<label class="form-label">
						생년월일 <span class="form-help form-help--required">*</span>
					</label>
					<div class="columns">
						<div class="column col-6">
							<input
								v-model="userBirth"
								class="form-input"
								type="text"
								placeholder="생년월일 8자리"
							/>
						</div>
						<div class="column col-6">
							<label class="form-radio form-inline">
								<input
									v-model="birthCalendar"
									type="radio"
									name="birth_calendar"
									value="S"
								/>
								<i class="form-icon"></i> 양력
							</label>
							<label class="form-radio form-inline">
								<input
									v-model="birthCalendar"
									type="radio"
									name="birth_calendar"
									value="D"
								/>
								<i class="form-icon"></i> 음력
							</label>
						</div>
					</div>

					<FormInputHint :message="validMessage.userBirth"></FormInputHint>
				</div>

				<div class="form-group">
					<label class="form-label">
						성별 <span class="form-help form-help--required">*</span>
					</label>
					<label class="form-radio form-inline">
						<input v-model="userSex" type="radio" name="user_sex" value="M" />
						<i class="form-icon"></i> 남성
					</label>
					<label class="form-radio form-inline">
						<input v-model="userSex" type="radio" name="user_sex" value="F" />
						<i class="form-icon"></i> 여성
					</label>
				</div>

				<div class="form-group">
					<label class="form-label">
						주소 <span class="form-help form-help--required">*</span>
					</label>
					<div class="columns">
						<div class="column col-7">
							<input
								v-model="zipcode"
								class="form-input"
								type="text"
								placeholder="우편번호"
								readonly
							/>
						</div>
						<div class="column col-5">
							<Btn
								@click="togglePostcodePopup"
								type="button"
								color="primary"
								medium
								block
								>우편번호 찾기
							</Btn>
						</div>
						<div v-show="isShowPostcodePopup" class="column col-12">
							<vue-daum-postcode
								style="height: 300px; overflow-y: auto"
								@complete="completeAddress($event)"
								:no-auto-mapping="false"
							></vue-daum-postcode>
						</div>
						<div class="column col-12">
							<input
								v-model="userAddr1"
								class="form-input"
								type="text"
								placeholder="주소"
								readonly
							/>
						</div>
						<div class="column col-12">
							<input
								v-model="userAddr2"
								ref="userAddr2"
								class="form-input"
								type="text"
								placeholder="상세 주소"
							/>
						</div>
					</div>
				</div>

				<div class="form-group">
					<label class="form-label"> 이용 지역/지점 </label>
					<div class="columns">
						<div class="column col-6">
							<select
								@change="changeBranchArea"
								v-model="branchPlace1"
								class="form-select"
							>
								<option value="">이용 지역</option>
								<option
									v-for="item in branchArea"
									:key="item.uid"
									:value="item.category_name"
								>
									{{ item.category_name }}
								</option>
							</select>
						</div>
						<div class="column col-6">
							<select v-model="branchPlace2" class="form-select">
								<option value="">이용 지점</option>
								<option
									v-for="item in branch"
									:key="item.uid"
									:value="item.mini_company"
								>
									{{ item.mini_company }}
								</option>
							</select>
						</div>
					</div>
				</div>

				<div class="form-group">
					<label class="form-label">
						방문 경로 <span class="form-help form-help--required">*</span>
					</label>
					<select v-model="visitChannel" class="form-select">
						<option value="">방문 경로</option>
						<option v-for="item in visitPath" :key="item.key" :value="item.key">
							{{ item.name }}
						</option>
					</select>
				</div>
			</section>

			<div class="form-group form-button">
				<Btn type="submit" color="primary" x-large block>완료</Btn>
			</div>
		</form>
	</div>
</template>

<script>
import mixin from '@/mixins/mixin';

import Vue from 'vue';

import VueDaumPostcode from 'vue-daum-postcode';

Vue.use(VueDaumPostcode);

import validation from '@/utils/validation';
import {
	fetchBranchArea,
	fetchBranchFromAreaName,
	fetchVisitPath,
	sendCertSms,
	checkCertNumber,
	isValidUserHp,
	isValidUserId,
	registerUser,
} from '@/api';

import FormInputHint from '@/components/common/FormInputHint';
import EmailInput from '@/components/common/EmailInput';
import Btn from '@/components/common/Btn';

export default {
	mixins: [mixin],
	components: {
		FormInputHint,
		EmailInput,
		Btn,
	},
	data() {
		return {
			userName: '',
			userHp: '',
			certNumber: '',

			userId: '',
			userPw: '',
			reUserPw: '',

			userEmail: '',

			userBirth: '',
			birthCalendar: 'S',

			userSex: '',

			zipcode: '',
			userAddr1: '',
			userAddr2: '',

			// 인증번호 발송 여부
			isSendCertSms: false,

			// 인증 완료 여부
			isCertSuccess: false,

			// 아이디 중복확인 여부
			isUserIdSuccess: false,

			// 주소찾기 팝업 노출 여부
			isShowPostcodePopup: false,

			// 이용 지역/지점
			branchPlace1: '',
			branchPlace2: '',

			branchArea: [],
			branch: [],

			// 방문 경로
			visitChannel: '',
			visitPath: [],

			// 유효성 검사
			validMessage: {},
			validCertNumber: '',
			validCheckUserId: '',
		};
	},
	watch: {
		userName(val) {
			this.validMessage.userName = validation.getValidUserName(val);
		},
		userHp(val) {
			this.validMessage.userHp = validation.getValidUserHp(val);
		},
		userId(val) {
			this.isUserIdSuccess = false;
			this.validCheckUserId = '';

			this.validMessage.userId = validation.getValidUserId(val);
			this.validMessage.userPw = validation.getValidUserPw(this.userPw, val);
		},
		userPw(val) {
			this.validMessage.userPw = validation.getValidUserPw(val, this.userId);
			this.validMessage.reUserPw = validation.getValidReUserPw(
				this.reUserPw,
				val,
			);
		},
		reUserPw(val) {
			this.validMessage.reUserPw = validation.getValidReUserPw(
				val,
				this.userPw,
			);
		},
		userEmail(val) {
			this.validMessage.userEmail = validation.getValidUserEmail(val);
		},
		userBirth(val) {
			this.validMessage.userBirth = validation.getValidUserBirth(val);
		},
	},
	methods: {
		init() {
			this.setBranchArea();
			this.setVisitPath();
		},
		onClickSendCertSms() {
			this.checkIsValidUserHp();
		},
		async checkIsValidUserHp() {
			const params = {
				userHp: this.userHp,
			};

			const { data } = await isValidUserHp(params);

			if (data.code === '00000') {
				this.sendCertSmsToUserHp();
			} else {
				const message = data.message;
				const options = {
					okLabel: '확인',
					message,
				};
				this.showAlert(options);
			}
		},
		async sendCertSmsToUserHp() {
			const params = {
				userName: this.userName,
				userHp: this.userHp,
			};

			const { data } = await sendCertSms(params);

			if (data.code === '00000') {
				this.isSendCertSms = true;
			} else {
				const message = data.message;
				const options = {
					message,
				};
				this.showAlert(options);
			}
		},
		async onClickCheckCertNumber() {
			const params = {
				userName: this.userName,
				userHp: this.userHp,
				certNumber: this.certNumber,
			};

			const { data } = await checkCertNumber(params);

			this.validCertNumber = data.message;

			// 인증 완료
			if (data.code === '00000') {
				this.isCertSuccess = true;
			}
		},
		async onClickCheckUserId() {
			// 21.06.02 | SD | 중복확인 버튼을 계속 활성화 시키면서 생기는 오류 사항
			if (validation.getValidUserId(this.userId) !== '') {
				return false;
			}

			const params = {
				userId: this.userId,
			};
			const { data } = await isValidUserId(params);

			this.validCheckUserId = data.message || '';
			this.isUserIdSuccess = data.code === '00000';
		},
		async setBranchArea() {
			const { data } = await fetchBranchArea();

			if (data.code === '00000') {
				this.branchArea = data.branchArea || [];
			} else {
				this.branchArea = [];
			}
		},
		async setVisitPath() {
			const { data } = await fetchVisitPath();
			this.visitPath = data;
		},
		changeBranchArea() {
			this.initBranch();
			this.setBranch();
		},
		initBranch() {
			this.branchPlace2 = '';
		},
		async setBranch() {
			const params = {
				categoryName: this.branchPlace1,
			};

			const { data } = await fetchBranchFromAreaName(params);

			if (data.code === '00000') {
				this.branch = data.branchFromAreaName || [];
			} else {
				this.branch = [];
			}
		},
		togglePostcodePopup() {
			this.showPostcodePopup(!this.isShowPostcodePopup);
		},
		completeAddress(result) {
			this.zipcode = result.zonecode;
			this.userAddr1 = result.address;

			this.showPostcodePopup(false);

			// 상세주소 입력란 포커스
			this.$refs.userAddr2.focus();
		},
		showPostcodePopup(show) {
			this.isShowPostcodePopup = show;
		},
		isInputRequired() {
			const required = !!(
				this.userName &&
				this.userHp &&
				this.userId &&
				this.userPw &&
				this.reUserPw &&
				this.userEmail &&
				this.userBirth &&
				this.userSex &&
				this.zipcode &&
				this.userAddr1 &&
				this.userAddr2 &&
				this.visitChannel
			);

			let isInputRequired = '';
			required ? (isInputRequired = true) : (isInputRequired = false);

			return isInputRequired;
		},
		isValidMessage() {
			let isValidMessage = false;

			for (const property in this.validMessage) {
				if (this.validMessage[property]) {
					isValidMessage = true;
					break;
				}
			}
			return isValidMessage;
		},
		async onSubmitForm() {
			if (!this.isInputRequired() || this.isValidMessage()) {
				const message =
					'회원 가입 시 필요한 정보를 올바르게 입력했는지 확인해주세요.';
				const options = {
					message,
				};
				this.showAlert(options);

				return false;
			}

			if (!this.isCertSuccess) {
				const message = '휴대전화 번호 인증은 필수입니다.';
				const options = {
					message,
				};
				this.showAlert(options);

				return false;
			}

			if (!this.isUserIdSuccess) {
				const message = '입력하신 아이디를 중복확인 해주세요.';
				const options = {
					message,
				};
				this.showAlert(options);

				return false;
			}

			const params = {
				userSms: this.$store.state.signupStore.userSms,
				userMailing: this.$store.state.signupStore.userMailing,

				userName: this.userName,
				userHp: this.userHp,
				isCertSuccess: this.isCertSuccess,

				userId: this.userId,
				userPw: this.userPw,
				reUserPw: this.reUserPw,

				userEmail: this.userEmail,

				userBirth: this.userBirth,
				birthCalendar: this.birthCalendar,

				userSex: this.userSex,

				zipcode: this.zipcode,
				userAddr1: this.userAddr1,
				userAddr2: this.userAddr2,

				branchPlace1: this.branchPlace1,
				branchPlace2: this.branchPlace2,

				visitChannel: this.visitChannel,
			};

			const { data } = await registerUser(params);

			if (data.code === '00000') {
				// 가입한 회원 이름 스토어에 저장
				this.$store.commit('signupStore/setUserName', params.userName);

				// 다음 단계
				const nextStep = this.$parent.step + 1;
				this.$emit('changeStep', nextStep);
			} else {
				const message = data.message;
				const options = {
					message,
				};
				this.showAlert(options);
			}
		},
	},
	created() {
		this.init();
	},
};
</script>

<style>
.vue-daum-postcode-container {
	height: 100% !important;
}
</style>
